import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { VolunteeringProspectsService } from '../../../volunteering-prospects.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringProspectsService, util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService, areaService: VolunteeringAreaService): GridSetup<VolunteerProspect> {

	return {
		rowName: { singular: 'All Closed Volunteer', plural: 'All Closed Volunteers' },
		getRowKey: row => '' + row.leadVolunteerId,
		stateKey: 'all-closed-volunteer',
		actions: getActions(service, dialogService, areaService),
		buttons: getButtons(service),
		columns: getColumns(util, domainData, app),
	}
}
